import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSmallFilePortal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.37868 1.87868C4.94129 1.31607 5.70435 1 6.5 1H13.5C13.7652 1 14.0196 1.10536 14.2071 1.29289L21.2071 8.29289C21.3946 8.48043 21.5 8.73478 21.5 9V20C21.5 20.7957 21.1839 21.5587 20.6213 22.1213C20.0587 22.6839 19.2957 23 18.5 23H6.5C5.70435 23 4.94129 22.6839 4.37868 22.1213C3.81607 21.5587 3.5 20.7957 3.5 20V4C3.5 3.20435 3.81607 2.44129 4.37868 1.87868ZM6.5 3C6.23478 3 5.98043 3.10536 5.79289 3.29289C5.60536 3.48043 5.5 3.73478 5.5 4V20C5.5 20.2652 5.60536 20.5196 5.79289 20.7071C5.98043 20.8946 6.23478 21 6.5 21H18.5C18.7652 21 19.0196 20.8946 19.2071 20.7071C19.3946 20.5196 19.5 20.2652 19.5 20V10H13.5C12.9477 10 12.5 9.55228 12.5 9V3H6.5ZM14.5 4.41421L18.0858 8H14.5V4.41421Z",
		fill: "#4338ca"
	})
});
export default SvgSmallFilePortal;
